export default {
    loading: "Carregando"
}